import React, { useState } from 'react';
import styled from 'styled-components';
import { Flex, Typo, CourseListCard, theme } from '../../../ui';
import { useTranslation } from 'react-i18next';
import CourseDetailsModal from './CourseDetailsModal';
const InventoryHeader = styled(Flex)`
  padding: 8px 0;
`;

const HeaderLabel = styled(Typo.Info)`
  letter-spacing: 1px;
`;

const EmptyState = styled(Flex)`
  padding: 40px 0;
`;

const CourseList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CatalogInventory = ({ courses, selectedIds, hideVAT, onToggle, onSort }) => {
  const { t } = useTranslation();
  const [selectedCourse, setSelectedCourse] = useState(null);

  const handleCardClick = (course) => {
    setSelectedCourse(course);
  };

  const handleCloseModal = () => {
    setSelectedCourse(null);
  };

  return (
    <>
      <InventoryHeader align='center' justify='space-between' width='100%'>
        <HeaderLabel $caps fontWeight='600' color={theme.colors.NEU_600}>
          {t('coursioNetwork.catalog.availableCourses')}
        </HeaderLabel>
      </InventoryHeader>

      <CourseList>
        {courses.map((course) => {
          const isSelected = selectedIds.has(course.id);
          return (
            <CourseListCard
              key={course.id}
              courseInfo={course}
              onSelect={onToggle}
              onCardClick={handleCardClick}
              hideVAT={hideVAT}
              isSelected={isSelected}
            />
          );
        })}
        {courses.length === 0 && (
          <EmptyState align='center' justify='center'>
            <Typo.Text color={theme.colors.NEU_600}>{t('coursioNetwork.catalog.noCoursesMatch')}</Typo.Text>
          </EmptyState>
        )}
      </CourseList>

      <CourseDetailsModal
        course={selectedCourse}
        open={!!selectedCourse}
        onClose={handleCloseModal}
        hideVAT={hideVAT}
      />
    </>
  );
};

export default CatalogInventory;
